export const getASIntegratorTemplateScriptSrc = (): string => {
  return "https://storage.googleapis.com/sb-ui/springboard.esm.js";
};

/**
 * Fetches the latest version of a template from the API using Bearer token authentication.
 * @param templateId - The initial template ID to fetch the latest version for
 * @param apiUrl - The API base URL for constructing the endpoint
 * @param getBearerToken - Callback to fetch Bearer token for authentication
 * @returns Promise containing the latest template data with id and initialId
 */
export const fetchLatestTemplateVersion = async (
  templateId: string,
  apiUrl?: string,
  getBearerToken?: () => Promise<string>
): Promise<{ id: string; initialId?: string }> => {

  // Validate required parameters
  if (!apiUrl) {
    throw new Error('apiUrl is required to fetch the latest template version');
  }

  if (!getBearerToken) {
    throw new Error('getBearerToken callback is required to fetch the latest template version');
  }

  try {
    // Fetch Bearer token from external service
    const bearerToken = await getBearerToken();

    // Construct endpoint URL
    const endpoint = `${apiUrl}/templates/${templateId}/latest`;

    // Make direct fetch call with Bearer token
    const response = await fetch(endpoint, {
      method: 'GET',
      headers: {
        authorization: bearerToken,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const latestTemplate = await response.json();

    return {
      id: latestTemplate.id,
      initialId: templateId
    };

  } catch (error) {
    console.error('Error fetching latest template version with Bearer token:', error);
    throw error;
  }
};